import { defineStore } from 'pinia'

export const useEventStore = defineStore('event', {
  state: () => ({
    currentEventId: null as string | null,
  }),
  actions: {
    clearCurrentEvent() {
      this.currentEventId = null
    },
  },
  persist: {
    pick: ['currentEventId'],
  },
})
